<qai-results-tab [title]="'results.ACCURACY' | transloco">
  @switch (state) {
    @case (AccuracyFeedbackState.Loading) {
      <app-message-block data-testId="accuracyLoadingState">
        <qai-loading size="medium" [label]="'results.ACCURACY_LOADING' | transloco" />
      </app-message-block>
    }

    @case (AccuracyFeedbackState.Clear) {
      <app-message-block [icon]="clearIcon" data-testId="accuracyClearState">
        {{ 'results.ACCURACY_ALL_CLEAR' | transloco }}
      </app-message-block>
    }

    @case (AccuracyFeedbackState.Error) {
      <app-message-block [icon]="errorIcon" data-testId="accuracyErrorState">
        {{ 'results.ACCURACY_ERROR' | transloco }}
      </app-message-block>
    }

    @case (AccuracyFeedbackState.Flagged) {
      <app-message-block [icon]="flaggedIcon" data-testId="accuracyFlaggedBanner">
        {{ 'results.ACCURACY_FLAGGED_MESSAGE' | transloco }}
      </app-message-block>

      @for (claim of claims; track claim.originalClaim) {
        <div class="accuracy-claim" data-testId="accuracyClaimCard">
          <div class="accuracy-claim__body">
            <qai-comparison-block
              kind="neutral"
              [title]="'results.ACCURACY_YOU_SAID' | transloco"
              [description]="claim.originalClaim"
            />
            <qai-comparison-block
              kind="brand"
              [title]="'results.ACCURACY_CLAIM_IDENTIFIED' | transloco"
              [description]="claim.normalizedClaim"
            />
            <qai-comparison-block
              kind="warning"
              [title]="'results.ACCURACY_MATERIALS_STATE' | transloco"
              [description]="claim.appliedFact"
            />
          </div>
        </div>
      }
    }
  }
</qai-results-tab>
